import type { TEncounter } from 'constants/types';

const LMPT: TEncounter[] = [
  {
    id: 0,
    pokemon: null,
    location: 'Starter',
    status: null,
    filterKey: 'lmpt-0',
    zoneID: []
  },
  {
    id: 1,
    pokemon: null,
    location: 'Twinleaf Town',
    status: null,
    filterKey: 'lmpt-1',
    zoneID: [
      422,
      425
    ]
  },
  {
    id: 2,
    pokemon: null,
    location: 'Route 201',
    status: null,
    filterKey: 'lmpt-2',
    zoneID: [
      354
    ]
  },
  {
    id: 3,
    pokemon: null,
    location: 'Lake Verity',
    status: null,
    filterKey: 'lmpt-3',
    zoneID: [
      323,
      324,
    ]
  },
  {
    id: 4,
    pokemon: null,
    location: 'Verity Lakefront - Egg',
    status: null,
    filterKey: 'lmpt-4',
    zoneID: [
      346
    ]
  },
  {
    id: 5,
    pokemon: null,
    location: 'Sandgem Town',
    status: null,
    filterKey: 'lmpt-5',
    zoneID: [
      429,
      434
    ]
  },
  {
    id: 6,
    pokemon: null,
    location: 'Route 202',
    status: null,
    filterKey: 'lmpt-6',
    zoneID: [
      355
    ]
  },
  {
    id: 7,
    pokemon: null,
    location: 'Jubilife City',
    status: null,
    filterKey: 'lmpt-7',
    zoneID: [
      21,
      0,
      8
    ]
  },
  {
    id: 12,
    pokemon: null,
    location: 'Route 204',
    status: null,
    filterKey: 'lmpt-12',
    zoneID: [
      358,
      357
    ]
  },
  {
    id: 13,
    pokemon: null,
    location: 'Ravaged Path',
    status: null,
    filterKey: 'lmpt-13',
    zoneID: [
      252
    ]
  },
  {
    id: 8,
    pokemon: null,
    location: 'Route 203',
    status: null,
    filterKey: 'lmpt-8',
    zoneID: [
      356
    ]
  },
  {
    id: 9,
    pokemon: null,
    location: 'Oreburgh Gate',
    status: null,
    filterKey: 'lmpt-9',
    zoneID: [
      255,
      256
    ]
  },
  {
    id: 10,
    pokemon: null,
    location: 'Oreburgh City',
    status: null,
    filterKey: 'lmpt-10',
    zoneID: [
      38,
      40,
      41,
      53
    ]
  },
  {
    id: 69,
    pokemon: null,
    location: 'Oreburgh Mine',
    status: null,
    filterKey: 'lmpt-69',
    zoneID: [
      195,
      196
    ]
  },
  {
    id: 11,
    pokemon: null,
    location: 'Mining Museum',
    status: null,
    filterKey: 'lmpt-11',
    zoneID: [
      49
    ]
  },
  {
    id: 23,
    pokemon: null,
    location: 'Route 207',
    status: null,
    filterKey: 'lmpt-23',
    zoneID: [
      364
    ]
  },
  {
    id: 14,
    pokemon: null,
    location: 'Floaroma Town',
    status: null,
    filterKey: 'lmpt-14',
    zoneID: [
      438,
      440
    ]
  },
  {
    id: 15,
    pokemon: null,
    location: 'Floaroma Meadow',
    status: null,
    filterKey: 'lmpt-15',
    zoneID: [
      253,
      254
    ]
  },
  {
    id: 16,
    pokemon: null,
    location: 'Valley Windworks',
    status: null,
    filterKey: 'lmpt-16',
    zoneID: [
      197,
      198
    ]
  },
  {
    id: 17,
    pokemon: null,
    location: 'Route 205',
    status: null,
    filterKey: 'lmpt-17',
    zoneID: [
      361,
      359
    ]
  },
  {
    id: 18,
    pokemon: null,
    location: 'Eterna Forest',
    status: null,
    filterKey: 'lmpt-18',
    zoneID: [
      199,
      200
    ]
  },
  {
    id: 19,
    pokemon: null,
    location: 'Eterna City',
    status: null,
    filterKey: 'lmpt-19',
    zoneID: [
      54,
      57,
    ]
  },
  {
    id: 108,
    pokemon: null,
    location: 'Eterna City Galactic Building',
    status: null,
    filterKey: 'lmpt-108',
    zoneID: [
      62,
      63,
      64,
      65
    ]
  },
  {
    id: 63,
    pokemon: null,
    location: 'Grand Underground',
    status: null,
    filterKey: 'lmpt-63',
    zoneID: []
  },
  {
    id: 20,
    pokemon: null,
    location: 'Old Chateau',
    status: null,
    filterKey: 'lmpt-20',
    zoneID: [
      311,
      310,
      313,
      306,
      314,
      308,
      312,
      309,
      307
    ]
  },
  {
    id: 50,
    pokemon: null,
    location: 'Route 211',
    status: null,
    filterKey: 'lmpt-50',
    zoneID: [
      378,
      377
    ]
  },
  {
    id: 24,
    pokemon: null,
    location: 'Mt. Coronet',
    status: null,
    filterKey: 'lmpt-24',
    zoneID: [
      204,
      205,
      208,
      209,
      210,
      211,
      215,
      203,
      214,
      213,
      206,
      207
    ]
  },
  {
    id: 51,
    pokemon: null,
    location: 'Route 216',
    status: null,
    filterKey: 'lmpt-51',
    zoneID: [
      395
    ]
  },
  {
    id: 21,
    pokemon: null,
    location: 'Route 206',
    status: null,
    filterKey: 'lmpt-21',
    zoneID: [
      362
    ]
  },
  {
    id: 22,
    pokemon: null,
    location: 'Wayward Cave',
    status: null,
    filterKey: 'lmpt-22',
    zoneID: [
      293,
      292
    ]
  },
  {
    id: 26,
    pokemon: null,
    location: 'Route 208',
    status: null,
    filterKey: 'lmpt-26',
    zoneID: [
      365
    ]
  },
  {
    id: 27,
    pokemon: null,
    location: 'Hearthome City - Egg',
    status: null,
    filterKey: 'lmpt-27',
    zoneID: [
      76,
      86,
      87,
      78,
      82,
      84,
      85,
      77,
      88,
      98
    ]
  },
  {
    id: 107,
    pokemon: null,
    location: 'Amity Square',
    status: null,
    filterKey: 'lmpt-107',
    zoneID: [251]
  },
  {
    id: 64,
    pokemon: null,
    location: 'Route 212',
    status: null,
    filterKey: 'lmpt-64',
    zoneID: [
      379,
      383
    ]
  },
  {
    id: 65,
    pokemon: null,
    location: 'Pokemon Mansion',
    status: null,
    filterKey: 'lmpt-65',
    zoneID: [
      380
    ]
  },
  {
    id: 39,
    pokemon: null,
    location: 'Trophy Garden',
    status: null,
    filterKey: 'lmpt-39',
    zoneID: [
      297
    ]
  },
  {
    id: 28,
    pokemon: null,
    location: 'Route 209',
    status: null,
    filterKey: 'lmpt-28',
    zoneID: [
      367
    ]
  },
  {
    id: 29,
    pokemon: null,
    location: 'Solaceon Town',
    status: null,
    filterKey: 'lmpt-29',
    zoneID: [
      446
    ]
  },
  {
    id: 30,
    pokemon: null,
    location: 'Solaceon Ruins',
    status: null,
    filterKey: 'lmpt-30',
    zoneID: [
      225,
      227,
      228,
      229,
      230,
      231,
      232,
      233,
      234,
      235,
      236,
      237,
      238,
      239,
      240,
      241,
      242,
      243
    ]
  },
  {
    id: 31,
    pokemon: null,
    location: 'Lost Tower',
    status: null,
    filterKey: 'lmpt-31',
    zoneID: [
      368,
      369,
      370,
      371,
      372
    ]
  },
  {
    id: 32,
    pokemon: null,
    location: 'Route 215',
    status: null,
    filterKey: 'lmpt-32',
    zoneID: [
      394
    ]
  },
  {
    id: 33,
    pokemon: null,
    location: 'Veilstone City',
    status: null,
    filterKey: 'lmpt-33',
    zoneID: [
      123,
      124,
      125,
      133,
      315,
      316,
      317,
      318,
      320,
      321
    ]
  },
  {
    id: 34,
    pokemon: null,
    location: 'Route 214',
    status: null,
    filterKey: 'lmpt-34',
    zoneID: [
      392
    ]
  },
  {
    id: 35,
    pokemon: null,
    location: 'Maniac Tunnel',
    status: null,
    filterKey: 'lmpt-35',
    zoneID: [
      296,
      295,
      294
    ]
  },
  {
    id: 36,
    pokemon: null,
    location: 'Valor Lakefront',
    status: null,
    filterKey: 'lmpt-36',
    zoneID: [
      347,
      348
    ]
  },
  {
    id: 37,
    pokemon: null,
    location: 'Route 213',
    status: null,
    filterKey: 'lmpt-37',
    zoneID: [
      385
    ]
  },
  {
    id: 62,
    pokemon: null,
    location: 'Pastoria City',
    status: null,
    filterKey: 'lmpt-62',
    zoneID: [
      110,
      112
    ]
  },
  {
    id: 38,
    pokemon: null,
    location: 'The Great Marsh',
    status: null,
    filterKey: 'lmpt-38',
    zoneID: [
      219, 220, 221, 222, 223, 224
    ]
  },
  {
    id: 40,
    pokemon: null,
    location: 'Route 210',
    status: null,
    filterKey: 'lmpt-40',
    zoneID: [
      373,
      374,
      375
    ]
  },
  {
    id: 41,
    pokemon: null,
    location: 'Celestic Town',
    status: null,
    filterKey: 'lmpt-41',
    zoneID: [
      456,
      464
    ]
  },
  {
    id: 42,
    pokemon: null,
    location: 'Fuego Ironworks',
    status: null,
    filterKey: 'lmpt-42',
    zoneID: [
      201,
      202
    ]
  },
  {
    id: 43,
    pokemon: null,
    location: 'Route 219',
    status: null,
    filterKey: 'lmpt-43',
    zoneID: [
      403
    ]
  },
  {
    id: 44,
    pokemon: null,
    location: 'Route 220',
    status: null,
    filterKey: 'lmpt-44',
    zoneID: [
      485
    ]
  },
  {
    id: 45,
    pokemon: null,
    location: 'Route 221',
    status: null,
    filterKey: 'lmpt-45',
    zoneID: [
      404,
      405
    ]
  },
  {
    id: 46,
    pokemon: null,
    location: 'Route 218',
    status: null,
    filterKey: 'lmpt-46',
    zoneID: [
      400
    ]
  },
  {
    id: 47,
    pokemon: null,
    location: 'Canalave City',
    status: null,
    filterKey: 'lmpt-47',
    zoneID: [
      24,
      26
    ]
  },
  {
    id: 48,
    pokemon: null,
    location: 'Iron Island',
    status: null,
    filterKey: 'lmpt-48',
    zoneID: [
      298,
      300,
      301,
      302,
      303
    ]
  },
  {
    id: 66,
    pokemon: null,
    location: 'Lake Valor',
    status: null,
    filterKey: 'lmpt-66',
    zoneID: [
      326,
      327,
      328
    ]
  },
  {
    id: 52,
    pokemon: null,
    location: 'Route 217',
    status: null,
    filterKey: 'lmpt-52',
    zoneID: [
      397
    ]
  },
  {
    id: 53,
    pokemon: null,
    location: 'Acuity Lakefront',
    status: null,
    filterKey: 'lmpt-53',
    zoneID: [
      351
    ]
  },
  {
    id: 54,
    pokemon: null,
    location: 'Snowpoint Temple',
    status: null,
    filterKey: 'lmpt-54',
    zoneID: [
      287,
      291,
      290,
      289,
      288,
      286
    ]
  },
  {
    id: 68,
    pokemon: null,
    location: 'Snowpoint City',
    status: null,
    filterKey: 'lmpt-68',
    zoneID: [
      159,
      161
    ]
  },
  {
    id: 67,
    pokemon: null,
    location: 'Lake Acuity',
    status: null,
    filterKey: 'lmpt-67',
    zoneID: [
      330
    ]
  },
  {
    id: 56,
    pokemon: null,
    location: 'Spear Pillar',
    status: null,
    filterKey: 'lmpt-56',
    zoneID: [
      212,
      216,
      624
    ]
  },
  {
    id: 57,
    pokemon: null,
    location: 'Sendoff Spring',
    status: null,
    filterKey: 'lmpt-57',
    zoneID: [
      263
    ]
  },
  {
    id: 58,
    pokemon: null,
    location: 'Route 222',
    status: null,
    filterKey: 'lmpt-58',
    zoneID: [
      407,
      408
    ]
  },
  {
    id: 59,
    pokemon: null,
    location: 'Sunyshore City',
    status: null,
    filterKey: 'lmpt-59',
    zoneID: [
      142,
      144,
      145,
      146
    ]
  },
  {
    id: 60,
    pokemon: null,
    location: 'Route 223',
    status: null,
    filterKey: 'lmpt-60',
    zoneID: [
      486
    ]
  },
  {
    id: 61,
    pokemon: null,
    location: 'Pokemon League',
    status: null,
    filterKey: 'lmpt-61',
    zoneID: [
      167,
      171,
      173,
      175,
      177,
      179,
      181
    ]
  },
  {
    id: 70,
    pokemon: null,
    location: 'Victory Road',
    status: null,
    filterKey: 'lmpt-70',
    zoneID: [
      244,
      245,
      246,
      247
    ]
  },
  {
    id: 71,
    pokemon: null,
    location: 'Route 224',
    status: null,
    filterKey: 'lmpt-71',
    zoneID: [
      411
    ]
  },
  {
    id: 78,
    pokemon: null,
    location: 'Fight Area',
    status: null,
    filterKey: 'lmpt-78',
    zoneID: [
      186
    ]
  },
  {
    id: 72,
    pokemon: null,
    location: 'Route 225',
    status: null,
    filterKey: 'lmpt-72',
    zoneID: [
      412
    ]
  },
  {
    id: 79,
    pokemon: null,
    location: 'Survival Area',
    status: null,
    filterKey: 'lmpt-79',
    zoneID: [
      465
    ]
  },
  {
    id: 73,
    pokemon: null,
    location: 'Route 226',
    status: null,
    filterKey: 'lmpt-73',
    zoneID: [
      487
    ]
  },
  {
    id: 74,
    pokemon: null,
    location: 'Route 227',
    status: null,
    filterKey: 'lmpt-74',
    zoneID: [
      414
    ]
  },
  {
    id: 75,
    pokemon: null,
    location: 'Route 228',
    status: null,
    filterKey: 'lmpt-75',
    zoneID: [
      416
    ]
  },
  {
    id: 76,
    pokemon: null,
    location: 'Route 229',
    status: null,
    filterKey: 'lmpt-76',
    zoneID: [
      420
    ]
  },
  {
    id: 80,
    pokemon: null,
    location: 'Resort Area',
    status: null,
    filterKey: 'lmpt-80',
    zoneID: [
      473
    ]
  },
  {
    id: 77,
    pokemon: null,
    location: 'Route 230',
    status: null,
    filterKey: 'lmpt-77',
    zoneID: [
      489
    ]
  },
  {
    id: 81,
    pokemon: null,
    location: 'Stark Mountain',
    status: null,
    filterKey: 'lmpt-81',
    zoneID: [
      260,
      261,
      259
    ]
  },
  {
    id: 82,
    pokemon: null,
    location: 'Turnback Cave',
    status: null,
    filterKey: 'lmpt-82',
    zoneID: [
      264,
      265,
      266,
      267,
      268,
      269,
      270,
      271,
      272,
      273,
      274,
      275,
      276,
      277,
      278,
      279,
      280,
      281,
      282,
      283,
      284
    ]
  },
  {
    id: 84,
    pokemon: null,
    location: 'Mt. Coronet - Articuno',
    status: null,
    filterKey: 'lmpt-84',
    zoneID: []
  },
  {
    id: 85,
    pokemon: null,
    location: 'Valley Windworks - Zapdos',
    status: null,
    filterKey: 'lmpt-85',
    zoneID: []
  },
  {
    id: 86,
    pokemon: null,
    location: 'Victory Road - Moltres',
    status: null,
    filterKey: 'lmpt-86',
    zoneID: []
  },
  {
    id: 87,
    pokemon: null,
    location: 'Oreburgh Gate - Mewtwo',
    status: null,
    filterKey: 'lmpt-87',
    zoneID: []
  },
  {
    id: 88,
    pokemon: null,
    location: 'Route 208 - Raikou',
    status: null,
    filterKey: 'lmpt-88',
    zoneID: []
  },
  {
    id: 89,
    pokemon: null,
    location: 'Route 211 - Entei',
    status: null,
    filterKey: 'lmpt-89',
    zoneID: []
  },
  {
    id: 90,
    pokemon: null,
    location: 'Route 213 - Suicune',
    status: null,
    filterKey: 'lmpt-90',
    zoneID: []
  },
  {
    id: 91,
    pokemon: null,
    location: 'Route 220 - Lugia',
    status: null,
    filterKey: 'lmpt-91',
    zoneID: []
  },
  {
    id: 92,
    pokemon: null,
    location: 'Lost Tower - Ho-Oh',
    status: null,
    filterKey: 'lmpt-92',
    zoneID: []
  },
  {
    id: 93,
    pokemon: null,
    location: 'Eterna Forest - Celebi',
    status: null,
    filterKey: 'lmpt-93',
    zoneID: []
  },
  {
    id: 94,
    pokemon: null,
    location: 'Snowpoint Temple - Regis',
    status: null,
    filterKey: 'lmpt-94',
    zoneID: []
  },
  {
    id: 95,
    pokemon: null,
    location: 'Fullmoon Island - Latis/Cresselia',
    status: null,
    filterKey: 'lmpt-95',
    zoneID: []
  },
  {
    id: 96,
    pokemon: null,
    location: 'Route 213 - Kyogre',
    status: null,
    filterKey: 'lmpt-96',
    zoneID: []
  },
  {
    id: 97,
    pokemon: null,
    location: 'Stark Mountain - Groudon',
    status: null,
    filterKey: 'lmpt-97',
    zoneID: []
  },
  {
    id: 98,
    pokemon: null,
    location: 'Pokemon League - Rayquaza',
    status: null,
    filterKey: 'lmpt-98',
    zoneID: []
  },
  {
    id: 99,
    pokemon: null,
    location: 'Solaceon Ruins - Jirachi',
    status: null,
    filterKey: 'lmpt-99',
    zoneID: []
  },
  {
    id: 100,
    pokemon: null,
    location: 'Veilstone City - Deoxys',
    status: null,
    filterKey: 'lmpt-100',
    zoneID: []
  },
  {
    id: 49,
    pokemon: null,
    location: 'Valor Cavern',
    status: null,
    filterKey: 'lmpt-49',
    zoneID: [
      328
    ]
  },
  {
    id: 55,
    pokemon: null,
    location: 'Acuity Cavern',
    status: null,
    filterKey: 'lmpt-55',
    zoneID: [
	  325
    ]
  },
  {
    id: 101,
    pokemon: null,
    location: 'Verity Cavern',
    status: null,
    filterKey: 'lmpt-101',
    zoneID: []
  },
  {
    id: 102,
    pokemon: null,
    location: 'Stark Mountain - Heatran',
    status: null,
    filterKey: 'lmpt-102',
    zoneID: []
  },
  {
    id: 103,
    pokemon: null,
    location: 'Turnback Cave - Giratina',
    status: null,
    filterKey: 'lmpt-103',
    zoneID: []
  },
  {
    id: 104,
    pokemon: null,
    location: 'Newmoon Island - Darkrai',
    status: null,
    filterKey: 'lmpt-104',
    zoneID: []
  },
  {
    id: 105,
    pokemon: null,
    location: 'Flower Paradise - Shaymin',
    status: null,
    filterKey: 'lmpt-105',
    zoneID: []
  },
  {
    id: 106,
    pokemon: null,
    location: 'Hall of Origin - Arceus',
    status: null,
    filterKey: 'lmpt-106',
    zoneID: []
  },

];

export default LMPT;
